module.exports = __webpack_public_path__ + "static/media/elas_aei.c6d46c79.md";